<template>
  <div>
    <v-parallax src="https://wallpaperaccess.com/full/1734330.jpg" id="hero">
      <div
        class="d-flex flex-column fill-height justify-center align-center text-white"
      >
        <div class="gretting">
          <h4 style="font-size: 30px; font-family: 'Poppins', sans-serif">
            Hello, I'm
          </h4>
        </div>
        <div class="typewriter">
          <h1 style="font-size: 50px; font-family: 'M PLUS 1 Code', sans-serif">
            <b>INDOVINO VALENTINO</b>
          </h1>
        </div>
        <h4 class="subheading" style="font-size: initial">
          A young <b style="color: #42b983">System's Analyst</b> with great
          skills in both front-end and back-end development
        </h4>
        <div>
          <a
            v-for="icon in icons"
            :key="icon"
            :href="icon.url"
            style="color: white"
            target="_blank"
          >
            <v-btn class="mx-3 icono" :icon="icon.icon" variant="text"></v-btn>
          </a>
        </div>
      </div>
    </v-parallax>
  </div>
</template>

<script>
export default {
  name: "HeroComponent",
  components: {},
  data: () => ({
    icons: [
      { icon: "mdi-github", url: "http://github.com/valenindovino" },
      { icon: "mdi-linkedin", url: "http://linkedin.com/in/valentinoindovino" },
      { icon: "mdi-instagram", url: "http://instagram.com/valenindovino" },
    ],
  }),
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=M+PLUS+1+Code&family=Poppins:wght@800&display=swap");
.typewriter h1 {
  overflow: hidden; /* Ensures the content is not revealed until the animation */
  border-right: 0.15em solid #42b983; /* The typwriter cursor */
  white-space: nowrap; /* Keeps the content on a single line */
  margin: 0 auto; /* Gives that scrolling effect as the typing happens */
  letter-spacing: 0.15em; /* Adjust as needed */
  animation: typing 3.5s steps(40, end), blink-caret 0.75s step-end infinite;
}

.gretting {
  width: 45%;
  text-align: left;
}

.icono:hover {
  color: #42b983;
  transition: 0.3s;
}

a {
  text-decoration: none;
}

@media screen and (max-width: 575px) {
  #hero {
    height: 700px;
  }

  #hero .gretting h4 {
    text-align: center !important;
    font-size: 20px !important;
  }

  .typewriter {
    width: fit-content !important;
    padding: 20px;
  }

  .typewriter h1 {
    font-size: x-large !important;
  }
}

/* The typing effect */
@keyframes typing {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}

/* The typewriter cursor effect */
@keyframes blink-caret {
  from,
  to {
    border-color: transparent;
  }
  50% {
    border-color: #42b983;
  }
}
</style>
